import { render } from "./accueil.vue?vue&type=template&id=3d533455"
import script from "./accueil.vue?vue&type=script&lang=js"
export * from "./accueil.vue?vue&type=script&lang=js"

import "./accueil.vue?vue&type=style&index=0&id=3d533455&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__